import { LINK_TITLE } from "../elements/link"

export const HISTORY_AND_UPCOMING = `
...on historyAndUpcoming_Entry {
  id
  typeHandle
  anchorId

  headingAdvanced {
    html
  }
  description

  centerTextWithCircle
  cards: metricCardsMatrix {
    badge
    title
    description
  }

  historyUpcomingMatrix {
    id
    when
    milestone
    statusDropdown {value}
    details
    ${ LINK_TITLE }
  }
}
`